import { makeStyles } from '@material-ui/core/styles';

export const mfaOtpStyles = makeStyles(theme => ({
    otpContainer: {
        maxWidth: '754px',
        marginTop: '40px',
        marginBottom: '120px',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '0px 30px',

        '@media(max-width: 599px)': {
            padding: '0px 12px',
            width: '100%',
            marginTop: '48px',
            marginBottom: '0px',
        },

        '& .MuiCheckbox-colorPrimary.Mui-checked': {
            color: theme.palette.primary.heather,
        },
    },
    otpcardContainer: {
        width: '100%',
        height: '100%',
        paddingLeft: '32px',
        paddingRight: '30px',
        paddingTop: '24px',
        paddingBottom: '24px',

        background: theme.palette.primary.white,
        boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
        borderRadius: '10px',

        '@media(max-width: 1019px)': {
            maxWidth: '570px',
            margin: '0 auto',
        },

        '@media(max-width: 599px)': {
            background: theme.palette.primary.white,
            boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
            borderRadius: '10px 10px 0px 0px',

            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '17.5px',
            paddingBottom: '17.5px',

            maxWidth: 'calc(312 / 360 * 100vw)',
            margin: '0 auto',
        },
    },
    otpcardContainerMFA: {
        position: 'relative',
        width: '100%',
        height: '100%',
        paddingLeft: '32px',
        paddingRight: '30px',
        paddingTop: '24px',
        paddingBottom: '24px',
        minHeight: '570px',
        background: theme.palette.primary.white,
        boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
        borderRadius: '10px',

        '@media(max-width: 1019px)': {
            maxWidth: '570px',
            minHeight: '570px',
            margin: '0 auto',
        },

        '@media(max-width: 599px)': {
            background: theme.palette.primary.white,
            boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
            borderRadius: '10px 10px 0px 0px',

            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '17.5px',
            paddingBottom: '17.5px',
            minHeight: '80vh',
            maxWidth: 'calc(312 / 360 * 100vw)',
            margin: '0 auto',
        },
    },
    body: {
        minHeight: '155px',
        margin: '0 auto',
        maxWidth: '391px',
        '@media(min-width:600px)': {
            paddingBottom: '40px',
        },
        [theme.breakpoints.down('xs')]: {
            minHeight: '294px',
            width: '248px',
        },
        '& .verification-code': {
            marginTop: '18px',
            width: '387px',
            color: theme.palette.primary.heather,
            borderColor: theme.palette.primary.heather,
            [theme.breakpoints.down('xs')]: {
                marginTop: '23px',
                width: '248px',
            },
        },

        '& .email-code': {
            width: '376px',
            color: theme.palette.primary.heather,
            borderColor: theme.palette.primary.heather,
            [theme.breakpoints.down('xs')]: {
                width: '248px',
            },
        },
        '& .reset-password': {
            marginTop: '51px',
            [theme.breakpoints.down('xs')]: {
                marginTop: '66px',
            },
        },
        '& .confirm-password': {
            marginTop: '21px',
            [theme.breakpoints.down('xs')]: {
                marginTop: '26px',
            },
        },

        '& .invalid-messages': {
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0.4px',
            color: theme.palette.primary.error,
            marginTop: '3px',
            fontFamily: theme.typography.inputLabel.fontFamily,
            fontStyle: 'normal',
            fontWeight: theme.typography.inputLabel.fontWeight,
            textAlign: 'left',
            marginBottom: '24px',
        },

        '& .dob-container': {
            marginTop: '51px',
            '@media(max-width: 599px)': {
                marginTop: '59px',
            },
        },
    },
    bodyMFA: {
        minHeight: '155px',
        margin: '0 auto',
        maxWidth: '391px',
        '@media(min-width:600px)': {
            paddingBottom: '40px',
        },
        [theme.breakpoints.down('xs')]: {
            minHeight: '294px',
            width: '256px',
        },
        '& .verification-code': {
            marginTop: '18px',
            width: '387px',
            color: theme.palette.primary.heather,
            borderColor: theme.palette.primary.heather,
            [theme.breakpoints.down('xs')]: {
                marginTop: '23px',
                width: '256px',
            },
        },

        '& .email-code': {
            width: '376px',
            color: theme.palette.primary.heather,
            borderColor: theme.palette.primary.heather,
            [theme.breakpoints.down('xs')]: {
                width: '248px',
            },
        },
        '& .reset-password': {
            marginTop: '51px',
            [theme.breakpoints.down('xs')]: {
                marginTop: '66px',
            },
        },
        '& .confirm-password': {
            marginTop: '21px',
            [theme.breakpoints.down('xs')]: {
                marginTop: '26px',
            },
        },

        '& .invalid-messages': {
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0.4px',
            color: theme.palette.primary.error,
            marginTop: '3px',
            fontFamily: theme.typography.inputLabel.fontFamily,
            fontStyle: 'normal',
            fontWeight: theme.typography.inputLabel.fontWeight,
            textAlign: 'left',
            marginBottom: '24px',
        },

        '& .dob-container': {
            marginTop: '51px',
            '@media(max-width: 599px)': {
                marginTop: '59px',
            },
        },
    },
    text: {
        marginTop: '42px',
        marginBottom: '16px',
        maxWidth: '387px',
        maxHeight: '96px',
        textAlign: 'left',
        fontFamily: theme.typography.body1.fontFamily,
        fontWeight: theme.typography.body1.fontWeight,
        fontSize: theme.typography.subtitle2.fontFamily,
        lineHeight: '157%',
        color: theme.palette.primary.heather,

        [theme.breakpoints.down('xs')]: {
            marginTop: '26px',
            marginBottom: '1px',
            maxWidth: '248px',
        },
    },
    middleText: {
        fontWeight: 700,
        //marginTop: '42px',
        //marginBottom: '16px',
        maxWidth: '256px',
        //maxHeight: '66px',
        textAlign: 'left',
        fontFamily: theme.typography.body1.fontFamily,
        fontSize: theme.typography.subtitle2.fontFamily,
        lineHeight: '157%',
        color: theme.palette.primary.heather,
        display: 'inline',
    },
    lastText: {
        display: 'inline',
        fontFamily: theme.typography.body1.fontFamily,
        fontSize: theme.typography.subtitle2.fontFamily,
        fontWeight: theme.typography.body1.fontWeight,
        color: theme.palette.primary.heather,
        [theme.breakpoints.down('xs')]: {
            display: 'block',
        },
    },

    emailText: {
        marginTop: '43px',
        marginBottom: '24px',
        maxWidth: '376px',
        maxHeight: '44px',
        textAlign: 'left',
        fontWeight: theme.typography.body2.fontWeight,
        fontSize: theme.typography.body2.fontSize,
        fontFamily: theme.typography.body2.fontFamily,
        lineHeight: '157%',
        color: theme.palette.primary.heather,
        margin: '0 auto',
        [theme.breakpoints.down('xs')]: {
            marginTop: '24px',
            maxWidth: '248px',
            paddingLeft: '8px',
            paddingRight: '8px',
        },
    },

    msg: {
        maxHeight: '44px',
        textAlign: 'left',
        fontWeight: theme.typography.body2.fontWeight,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '157%',
        color: theme.palette.primary.heather,
        fontFamily: theme.typography.body2.fontFamily,
        [theme.breakpoints.down('xs')]: {
            marginBottom: '56px',
        },
    },

    phone: {
        marginBottom: '3px',
        maxWidth: '203px',
        maxHeight: '16px',
        textAlign: 'left',
        fontFamily: theme.typography.caption.fontFamily,
        fontWeight: theme.typography.caption.fontWeight,
        fontSize: theme.typography.caption.fontSize,
        lineHeight: theme.typography.caption.lineHeight,
        color: theme.palette.primary.heather,
    },
    number: {
        maxWidth: '203px',
        maxHeight: '21px',
        textAlign: 'left',
        fontFamily: theme.typography.caption.fontFamily,
        fontWeight: theme.typography.caption.fontWeight,
        fontSize: theme.typography.caption.fontSize,
        lineHeight: theme.typography.caption.lineHeight,
        color: theme.palette.primary.heather,
    },
    codes: {
        ' & .text-field-input-label-props-root': {
            color: theme.palette.primary.heather,
            fontFamily: theme.typography.inputText.fontFamily,
            fontStyle: 'normal',
            fontWeight: theme.typography.inputText.fontWeight,
            fontSize: theme.typography.inputText.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            letterSpacing: '0.15px',
            // paddingTop:'6px',
        },
        '& .text-field-input-label-props-focused, & .text-field-input-label-props-shrink': {
            color: theme.palette.primary.heather80,
            fontSize: '14.5px',
            lineHeight: '16px',
        },
        '& .text-field-input-label-props-focused-invalid, & .text-field-input-label-props-shrink-invalid': {
            color: theme.palette.primary.error,
        },
        ' & .text-field-input-props-root': {
            '& .text-field-input-props-input': {
                color: theme.palette.primary.heather,
                fontFamily: theme.typography.inputText.fontFamily,
                fontStyle: 'normal',
                fontWeight: theme.typography.inputText.fontWeight,
                fontSize: theme.typography.inputText.fontSize,
                lineHeight: theme.typography.inputText.lineHeight,
                letterSpacing: '0.15px',

                padding: '14px 12px 13px 12px',
            },
        },
        ' & .text-field-input-props-root-filled': {
            ' & .text-field-input-props-notchedOutline': {
                borderColor: theme.palette.primary.heather80,
                borderWidth: '2px',
            },
            ' & .text-field-input-props-notchedOutline-invalid': {
                borderColor: theme.palette.primary.error,
            },
        },
        ' & .text-field-input-props-focused, & .text-field-input-props-root:hover': {
            ' & .text-field-input-props-notchedOutline': {
                borderColor: theme.palette.primary.heather80,
            },
            ' & .text-field-input-props-notchedOutline-invalid': {
                borderColor: theme.palette.primary.error,
            },
        },
    },

    resend: {
        marginBottom: '32px',
        maxWidth: '248px',
        maxHeight: '20px',
        textAlign: 'left',
        cursor: 'text',
        fontFamily: theme.typography.body2.fontFamily,
        fontWeight: 'normal',
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        color: theme.palette.primary.heather,
        marginTop: '4px',
        letterSpacing: '0.4px',
        [theme.breakpoints.down('xs')]: {
            marginBottom: '16px',
        },
    },
    link: {
        marginBottom: '32px',
        maxWidth: '248px',
        maxHeight: '20px',
        textAlign: 'left',
        cursor: 'pointer',
        fontFamily: theme.typography.body2.fontFamily,
        fontWeight: 'normal',
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        color: '#DD1D78',
        textDecoration: 'underline',
        letterSpacing: '0.4px',
        marginLeft: '2px',
        [theme.breakpoints.down('xs')]: {
            marginBottom: '16px',
        },
    },

    errormessage: {
        '& .invalid-messages': {
            fontSize: theme.typography.overline.fontSize,
            lineHeight: theme.typography.overline.lineHeight,
            letterSpacing: '0.4px',
            color: theme.palette.primary.error,
            marginTop: '-22px',
            fontFamily: theme.typography.overline.fontFamily,
            fontStyle: 'normal',
            fontWeight: theme.typography.overline.fontWeight,
            textAlign: 'left',
        },
    },
    contactText: {
        // marginTop: '24px',
        // marginBottom: '24px',

        marginTop: '42px',
        marginBottom: '16px',
        maxWidth: '387px',
        maxHeight: '96px',
        textAlign: 'left',
        fontFamily: theme.typography.body1.fontFamily,
        fontWeight: theme.typography.body1.fontWeight,
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '157%',
        color: theme.palette.primary.heather,

        [theme.breakpoints.down('xs')]: {
            marginTop: '26px',
            marginBottom: '24px',
            maxWidth: '256px',
        },
    },
    phoneIcon: {
        marginRight: '14px',
    },
    contactNum: {
        fontSize: theme.typography.subtitle1.fontSize,
        lineHeight: theme.typography.subtitle1.lineHeight,
        letterSpacing: '0.4px',

        // marginTop: '-22px',
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontStyle: 'normal',
        fontWeight: theme.typography.subtitle1.fontWeight,
    },
    notice: {
        marginTop: '20px',
        '@media(max-width: 599px)': {
            marginTop: '26px',
            width: '256px',
        },
    },
    gridRecaptcha: {
        marginTop: '7rem',
        [theme.breakpoints.down('xs')]: {
            marginTop: '8rem',
        },
    },
    reCaptcha: {
        paddingBottom: '32px',

        [theme.breakpoints.down('xs')]: {
            paddingTop: '16px',
            paddingBottom: '16px',
            transform: 'scale(0.77)',
            transformOrigin: '0 0',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            paddingBottom: '32px',
            // marginLeft: '75px',
        },
    },

    errormessage: {
        '& .invalid-messages': {
            fontSize: theme.typography.overline.fontSize,
            lineHeight: theme.typography.overline.lineHeight,
            letterSpacing: '0.4px',
            color: theme.palette.primary.error,
            marginTop: '-22px',
            fontFamily: theme.typography.overline.fontFamily,
            fontStyle: 'normal',
            fontWeight: theme.typography.overline.fontWeight,
            textAlign: 'left',
        },
    },
    footer: {
        position: 'absolute',
        bottom: '10%',
        left: 0,
        width: '100%',

        // '@media(min-width: 599px) and (max-width: 1099px)': {
        //     position: 'absolute',
        //     bottom: '28%',
        //     left: 0,
        //     width: '100%',
        // },

        // '@media(max-width: 599px) and (max-height: 650px)': {
        //     position: 'absolute',
        //     bottom: '-25px !important',
        //     left: 0,
        //     width: '100%',
        // },
        '@media(max-width: 599px)': {
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
        },
    },
}));
